// export default {
//     // getCusMsgTemplateConfig:'', //获取模板信息
//     // getTemplateFieldsInfo:'',//自定义字段
//     // getUserTicketInfoList:'',//留言列表
//     // postMsg:'',//添加留言
//     // getUserDealTicketInfoList:'',//获取留言详情
//     // isMessage:'',//是否留言
//     // postMsgAfterVerify:'/chat/data/postMsgAfterVerify.action',
//     // addTicketSatisfactionScoreInfo:'/chat-web/invoke/addTicketSatisfactionScoreInfo.action',
//     // getTicketTypeInfoList:''//查询分类接口
// }
import axios from 'axios';
import { stringify } from 'qs';
import {URL_DOMAIN, TEXT_PREFIX } from '../../config.json'
// 获取模板信息
export async function getCusMsgTemplateConfig(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/invoke/getCusMsgTemplateConfig.action?${stringify(params)}`);
}
// 留言列表
export async function getUserTicketInfoList(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/user/getUserTicketInfoList.action?${stringify(params)}`);
}
// 自定义字段
export async function getTemplateFieldsInfo(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/invoke/getTemplateFieldsInfo.action?${stringify(params)}`);
}
// 获取留言详情
export async function getUserDealTicketInfoList(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/invoke/getUserDealTicketInfoList.action?${stringify(params)}`);
}
// 查询分类接口
export async function getTicketTypeInfoList(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/invoke/queryTicketTypeInfoList.action?${stringify(params)}`);
}
// 添加留言
export async function postMsg(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/data/postMsg.action`, params);
}
// 是否留言
export async function isMessage(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat/data/isMessage.action`, params);
}
//
export async function postMsgAfterVerify(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat/data/postMsgAfterVerify.action`, params);
}
// /chat-web/invoke/addTicketSatisfactionScoreInfo.action
export async function addTicketSatisfactionScoreInfo(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/invoke/addTicketSatisfactionScoreInfo.action`, params);
}
// 提交回复
export async function invokeOtherByUser(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/data/invokeOtherByUser.action`, params);
}

// 新回复
// /chat-web/leaveMsg/saveUserReplyInfo.action
export async function saveUserReplyInfo(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/chat-web/leaveMsg/saveUserReplyInfo.action`, params);
}

// // 发送邮件
// export async function sendVerificationCode(params) {
//     return axios.get(`/ws-service/sendVerificationCode/4?${stringify(params)}`);
// }

// // 验证验证码
// export async function checkVerificationCode(params) {
//     return axios.get(`/ws-service/checkVerificationCode/4?${params}`);
// }

// 获取短信模块是否可用
export async function checkTicketValidateStatus(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/ws-service/checkTicketValidateStatus/4?${stringify(params)}`);
}

// 短信验证码校验
export async function checkSmsVerificationCode(params) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/ws-service/checkSmsVerificationCode/4?${stringify(params)}`);
}

// 验证码短信发送
export async function sendVerificationCodeBySms(params) {
    return axios.post(`${URL_DOMAIN}${TEXT_PREFIX}/ws-service/sendVerificationCodeBySms/4`, params);
}

// 工单状态列表查询
export async function getTicketStatusInfoList(params = {}) {
    return axios.get(`${URL_DOMAIN}${TEXT_PREFIX}/ws-service/ticketStatusConfig/getUserTicketStatusInfoList?${stringify(params)}`);
}
